<component :is="componentName" v-bind="props" :options="options"></component>